export const PERFORMANCE_MONITOR_PARAMS = [
    'version',
    'id',
    'sequence',
    'measure',
    'first_render_duration',
    'first_render_name',
    'last_render_duration',
    'last_render_name',
    'shortest_render_duration',
    'shortest_render_name',
    'longest_render_duration',
    'longest_render_name',
    'average_render_duration',
    'render_count',
    'first_track_duration',
    'first_track_name',
    'last_track_duration',
    'last_track_name',
    'shortest_track_duration',
    'shortest_track_name',
    'longest_track_duration',
    'longest_track_name',
    'average_track_duration',
    'track_count',
    'start_reason',
    'stop_reason',
    'pending_tracks',
    'duration_exclusive',
    'duration_inclusive',
    'data'
];

//# sourceMappingURL=constants.js.map